/* Hina Rathore — storefront behaviour.
   Ported from the approved static build: hero slider, category panel,
   mobile accordion, reveal-on-scroll, WhatsApp button, film playback. */

/* ── films ────────────────────────────────────────────────────────────────
   H.264 where the browser has the decoder, VP9 where it doesn't. */
(function(){
  var h264 = !!document.createElement('video').canPlayType('video/mp4; codecs="avc1.42E01E"'),
      kind = h264 ? 'mp4' : 'webm';
  document.querySelectorAll('.reel video').forEach(function(v){
    var src = v.getAttribute('data-' + kind) || v.getAttribute('data-mp4');
    if (!src) return;
    v.src = src;
    v.play().catch(function(){});
  });
})();

/* ── WhatsApp ──────────────────────────────────────────────────────────────
   Appears once the hero is behind you. On a product page the message is
   pre-filled with the piece and its SKU, so an enquiry arrives already
   knowing what it is about. */
(function(){
  var wa = document.getElementById('wa');
  if (!wa) return;

  function show(){ wa.classList.toggle('on', scrollY > 380); }
  addEventListener('scroll', show, {passive:true});
  show();
})();

/* header shrink */
var hd = document.getElementById('hd');
addEventListener('scroll', function(){ hd.classList.toggle('small', scrollY > 60); }, {passive:true});

/* reveal — slow, once */
var io = new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
}, {threshold:.08, rootMargin:'0px 0px -4% 0px'});
document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

/* ── the category panel ────────────────────────────────────────────────────
   Opens on hover and on focus, so it works with a keyboard as well as a
   mouse. A short close delay means you can cross the gap into the panel. */
var mega = document.getElementById('mega'),
    nav  = document.getElementById('nav'),
    tabs = nav.querySelectorAll('[data-m]'),
    panes = mega.querySelectorAll('.mega__p'),
    shut;

function open(key){
  clearTimeout(shut);
  panes.forEach(function(p){ p.classList.toggle('on', p.dataset.p === key); });
  tabs.forEach(function(t){ t.setAttribute('aria-expanded', t.dataset.m === key ? 'true' : 'false'); });
  mega.classList.add('on');
}
function close(now){
  clearTimeout(shut);
  shut = setTimeout(function(){
    mega.classList.remove('on');
    tabs.forEach(function(t){ t.setAttribute('aria-expanded', 'false'); });
  }, now ? 0 : 160);
}
tabs.forEach(function(t){
  t.addEventListener('mouseenter', function(){ open(t.dataset.m); });
  t.addEventListener('focus',      function(){ open(t.dataset.m); });
  /* the tab is a real link now — a click goes to the category page rather
     than toggling a panel that the customer has to guess at. */
});
nav.addEventListener('mouseleave', function(){ close(); });
mega.addEventListener('mouseenter', function(){ clearTimeout(shut); });
mega.addEventListener('mouseleave', function(){ close(); });
addEventListener('scroll', function(){ if (mega.classList.contains('on')) close(1); }, {passive:true});

/* ── slider ────────────────────────────────────────────────────────────────
   Scroll position is the source of truth, so swipe, dots and the auto
   advance can never disagree. */
var track = document.getElementById('track'),
    slides = track ? track.children : [],
    dots = document.getElementById('dots'),
    idx = 0, timer;
if (track) {

for (var i = 0; i < slides.length; i++) {
  (function(n){
    var b = document.createElement('button');
    b.setAttribute('aria-label', 'Slide ' + (n + 1));
    b.onclick = function(){ jump(n); rest(); };
    dots.appendChild(b);
  })(i);
}
function paint(){
  for (var i = 0; i < dots.children.length; i++)
    dots.children[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
}
function jump(n){
  idx = (n + slides.length) % slides.length;
  track.scrollTo({left: idx * track.clientWidth, behavior: 'smooth'});
  paint();
}
function go(d){ jump(idx + d); rest(); }
function rest(){ clearInterval(timer); timer = setInterval(function(){ jump(idx + 1); }, 7000); }

var t;
track.addEventListener('scroll', function(){
  clearTimeout(t);
  t = setTimeout(function(){
    var n = Math.round(track.scrollLeft / track.clientWidth);
    if (n !== idx) { idx = n; paint(); rest(); }
  }, 90);
}, {passive:true});
addEventListener('resize', function(){ track.scrollLeft = idx * track.clientWidth; });
paint(); rest();
}   /* end slider */

/* ── mobile menu ───────────────────────────────────────────────────────── */
function mn(on){ document.getElementById('mn').classList.toggle('on', !!on); }
function acc(btn){
  var row = btn.parentNode, was = row.classList.contains('on');
  document.querySelectorAll('.mn__cat').forEach(function(c){ c.classList.remove('on'); });
  row.classList.toggle('on', !was);
}
addEventListener('keydown', function(e){
  if (e.key === 'Escape') { mn(0); close(1); }
  if (track && e.key === 'ArrowRight') go(1);
  if (track && e.key === 'ArrowLeft') go(-1);
});


/* ── size radio updates the price ─────────────────────────────────────── */
(function(){
  var box = document.querySelector('.sizes'), out = document.getElementById('price');
  if (!box || !out) return;
  box.addEventListener('change', function(e){
    var p = e.target && e.target.dataset ? e.target.dataset.price : null;
    if (p) out.textContent = p;
  });
})();


/* ── lightbox ──────────────────────────────────────────────────────────────
   The embroidery is the product. A thumbnail cannot sell it, so any product
   photograph opens full size, with arrows and swipe between them. */
(function(){
  var gal = document.querySelector('.pd__gal');
  if (!gal) return;
  var shots = [].slice.call(gal.querySelectorAll('img')), at = 0;

  var box = document.createElement('div');
  box.className = 'lb';
  box.innerHTML =
    '<button class="lb__x" aria-label="Close">&times;</button>' +
    '<button class="lb__p" aria-label="Previous"><svg viewBox="0 0 24 8"><path d="M24 4H2M6 1 2 4l4 3"/></svg></button>' +
    '<img alt="">' +
    '<button class="lb__n" aria-label="Next"><svg viewBox="0 0 24 8"><path d="M0 4h22M18 1l4 3-4 3"/></svg></button>' +
    '<div class="lb__c"></div>';
  document.body.appendChild(box);

  var pic = box.querySelector('img'), cap = box.querySelector('.lb__c');

  function paint(){
    var s = shots[at];
    pic.src = s.currentSrc || s.src;
    pic.alt = s.alt || '';
    cap.textContent = (at + 1) + ' / ' + shots.length;
  }
  function show(i){
    at = (i + shots.length) % shots.length;
    paint();
    box.classList.add('on');
    requestAnimationFrame(function(){ box.classList.add('in'); });
    document.body.style.overflow = 'hidden';
  }
  function hide(){
    box.classList.remove('in');
    setTimeout(function(){ box.classList.remove('on'); }, 320);
    document.body.style.overflow = '';
  }
  function step(d){ at = (at + d + shots.length) % shots.length; paint(); }

  shots.forEach(function(img, i){
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function(){ show(i); });
  });
  box.querySelector('.lb__x').addEventListener('click', hide);
  box.querySelector('.lb__p').addEventListener('click', function(e){ e.stopPropagation(); step(-1); });
  box.querySelector('.lb__n').addEventListener('click', function(e){ e.stopPropagation(); step(1); });
  pic.addEventListener('click', hide);
  box.addEventListener('click', function(e){ if (e.target === box) hide(); });
  addEventListener('keydown', function(e){
    if (!box.classList.contains('on')) return;
    if (e.key === 'Escape') hide();
    if (e.key === 'ArrowRight') step(1);
    if (e.key === 'ArrowLeft') step(-1);
  });

  /* swipe */
  var x0 = null;
  box.addEventListener('touchstart', function(e){ x0 = e.changedTouches[0].clientX; }, {passive:true});
  box.addEventListener('touchend', function(e){
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1);
    x0 = null;
  }, {passive:true});
})();
